module.exports = __webpack_public_path__ + "static/media/22.e6dc7d76.mp3";